import { useTranslation } from 'react-i18next'

import { Search } from '@/Atomic/Molecules/Inputs/Search'
import { DocumentsBreadcrumb } from '@/Components/Document/DocumentsBreadcrumb'
import { DocumentsConfigOrderSelect } from '@/Components/Document/DocumentsConfig/DocumentsConfigOrderSelect'
import { DocumentsUploadTool } from '@/Components/Document/DocumentUploadTool'
import { NewFolderModal } from '@/Components/Document/Modal/NewFolderModal'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'
import { useModalHandler } from '@/hooks/useModalHandler'

export const DocumentTabConfig: React.FC = () => {
  const { t } = useTranslation()
  const { setSearch, showNewFolderButton } = useDocumentContext()
  const { isOpen, closeModal } = useModalHandler()

  return (
    <>
      <div className="tab-header-wrapper">
        <div className="search-filter">
          <Search
            onChange={(e) => setSearch(e.target.value)}
            name="document-relation-search"
            placeholder={t('search.title')}
            searchWrapperClassName="tab-header-search"
          />
          <DocumentsConfigOrderSelect />
        </div>
        <div className="tab-header-actions">
          {showNewFolderButton && (
            <NewFolderModal isOpen={isOpen} close={closeModal} />
          )}
          <DocumentsUploadTool />
        </div>
      </div>
      <DocumentsBreadcrumb />
    </>
  )
}
